import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/WhyNexa.css";

const Welcome = () => {
  return (
    <section className="Why-section">
      <div className="Why-container">
        <div className="Why-component">
          <div className="Welcome-image">
            <img
              src="https://images.unsplash.com/photo-1739298061740-5ed03045b280?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Office environment"
            />
          </div>
          <div className="Why-details">
            <h2 className="Why-heading">
              <span>Our </span> <span className="light">Mission</span>
            </h2>
            <p className="Why-description">
              To empower organizations and entrepreneurs with strategic tools,
              market insights, and digital innovation that drive sustainable
              success.
            </p>
          </div>
        </div>
        <div className="Why-component">
          <div className="Why-details">
            <h2 className="Why-heading">
              <span>Our </span> <span className="light">Vision</span>
            </h2>
            <p className="Why-description">
              To be Africa’s leading catalyst for enterprise growth, innovation,
              and inclusive development.
            </p>
          </div>
          <div className="Welcome-image">
            <img
              src="https://images.unsplash.com/photo-1669710208503-d88214727bac?q=80&w=2036&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Office environment"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
